import * as ActionTypes from "../action-types";

const initialState = {
    errorTitle: '',
    errorMessage: '',
    showErrorAlert: false,

    successTitle: '',
    successMessage: '',
    showSuccessAlert: false,
    tariffs: [],
    adminTariffs: [],
    hiddenTariffs: [],
    hiddenSites: [],
    adminSites: []
}

const Common = (state= initialState,{type,payload = null}) => {
    switch(type){
        case ActionTypes.SHOW_ERROR_MESSAGE:
            return {...state, errorTitle: payload.title, errorMessage: payload.message, showErrorAlert: true}
        case ActionTypes.HIDE_ERROR_MESSAGE:
            return {...state, errorTitle: '', errorMessage: '', showErrorAlert: false}
        case ActionTypes.SHOW_SUCCESS_MESSAGE:
            return {...state, successTitle: payload.title, successMessage: payload.message, showSuccessAlert: true}
        case ActionTypes.HIDE_SUCCESS_MESSAGE:
            return {...state, successTitle: '', successMessage: '', showSuccessAlert: false}
        case ActionTypes.SET_TARIFFS:
            let res = {...state, tariffs: payload.tariffs, adminTariffs: payload.adminTariffs, adminSites: payload.adminSites}
            if (!!payload.hiddenSites) {
                res.hiddenTariffs = payload.hiddenTariffs
                res.hiddenSites = payload.hiddenSites
            }
            return res
        default:
            return state;
    }
};

export default Common